import { Navigate, Outlet, useLocation } from "react-router-dom";

const PrivateRoute = () => {
  const location = useLocation();

  // you store full auth in localStorage as 'auth'
  const auth = JSON.parse(localStorage.getItem("auth"));
  const token = auth?.token;

  if (!token) {
    if (location.pathname.startsWith("/pos")) {
      return (
        <Navigate
          to="/pos/login"
          state={{ from: location.pathname }}
          replace
        />
      );
    }

    return (
      <Navigate
        to="/login"
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return <Outlet />;
};

export default PrivateRoute;






// import { Navigate, Outlet } from "react-router-dom";

// const PrivateRoute = ({ isAuthenticated  }) => {
//   return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
// };

// export default PrivateRoute;
